<!-- Curtis Direct SSO -->

<div class='quick-link'>
  <a href="javascript:void(0)" (click)="submitSSOForm();" class="external-link">
    {{ label || 'Online Order Site' }}
    <span class="material-symbols-outlined">open_in_new</span>
  </a>
</div>

<!-- <div class="site-wrapper-link"> -->
<!-- <form id="online-order-form1" target="_blank" class="form-curtis" -->
<!-- action="https://train.curtisdirect.com/sso/gensso.cfm" method="post"> -->
<!-- <input type="hidden" name="iv-user" id="input-curtis"> -->
<!-- <a tabindex="0" id="orderSite1"> -->
<!-- <span>{{ label || "Online Order Site" }}</span> -->
<!-- </a> -->
<!-- </form> -->
<!-- </div> -->

<!-- 
<div class="order-wrapper-link">
  <span class="order-class-span1 link-clr">
    <form id="online-order-form2" target="_blank" class="form-curtis"
      action="https://train.curtisdirect.com/sso/gensso.cfm" method="post">
      <input type="hidden" name="iv-user" id="input-curtis2">
      <a tabindex="0" id="orderSite2" class="under-line">ORDER MULTIPLE COPIES</a>.
    </form>
  </span> -->
<!-- <div class="order-class-span2">
    <span>If you need 10 or more copies of available printed materials, place your order via the Online Order Site. The
      Product description for each item under "RESOURCES" below will confirm if printed material is available to
      order.</span>
  </div> -->